module.exports = __webpack_public_path__ + "assets/img/returnBtn-0e48de7c.png";